import { BankAccount, CreditCard, Frequency } from '../types'
import { SelectPaymentMethodListItem } from './SelectPaymentMethodListItem'
import {
  creditCardWarningText,
  isCreditCardAmountTooHigh
} from './CreditCardLimitWarning'

export const SelectPaymentMethodList = ({
  bankAccounts,
  creditCards,
  amount,
  bankAccountId,
  creditCardId,
  setCreditCardId,
  setBankAccountId,
  paymentMethod,
  frequency
}: {
  bankAccounts: BankAccount[]
  creditCards: CreditCard[]
  bankAccountId: string | null
  creditCardId: string | null
  setCreditCardId: (id: string | null) => void
  setBankAccountId: (id: string | null) => void
  paymentMethod: {
    bankAccount: BankAccount | null | undefined
    creditCard: CreditCard | null | undefined
  }
  amount: number
  frequency: Frequency
}) => {
  return (
    <div>
      {bankAccounts.map((bankAccount: BankAccount) => {
        const { bankLabel, accountLabel, name } = bankAccount

        return (
          <SelectPaymentMethodListItem
            key={bankAccount.id}
            icon="bank-account"
            disabled={false}
            checked={bankAccountId === bankAccount.id}
            onClick={() => {
              setCreditCardId(null)
              setBankAccountId(bankAccount.id)
            }}
            title={`${bankLabel} ${name} ${accountLabel}`}
            description="No credit/debit processing fee"
          />
        )
      })}
      {creditCards.map((creditCard: CreditCard) => {
        const creditCardAmountTooHigh = isCreditCardAmountTooHigh({
          paymentMethod,
          amount,
          frequency,
          doNotCheckForBA: true
        })
        const { accountLabel, bankLabel, expiration } = creditCard
        return (
          <SelectPaymentMethodListItem
            key={creditCard.id}
            icon="credit-card"
            disabled={creditCardAmountTooHigh}
            title={`${bankLabel} ${accountLabel} ${expiration}`}
            description={
              creditCardAmountTooHigh && frequency
                ? creditCardWarningText(frequency)
                : 'Credit card (3% fee)'
            }
            checked={creditCardId === creditCard.id}
            onClick={() => {
              setBankAccountId(null)
              setCreditCardId(creditCard.id)
            }}
          />
        )
      })}
    </div>
  )
}
